import React from 'react';
import { Modal, Table, Form, Empty, Input, Tag } from 'antd';
import { REGISTRADO, APROBADO_COMPRA, ANULADO } from '../../../common/types/compraEstadoType';

export default class ImportarCompraModal extends React.Component {
    render() {
        const renderColor = (row) => {
            if (row.idCompraEstado == REGISTRADO)
                return 'blue';
            if (row.idCompraEstado == APROBADO_COMPRA)
                return 'green';
            if (row.idCompraEstado == ANULADO)
                return 'orange';
     
        };


        return (
            <Modal
                title={"Búsqueda de Compras"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="950px"
                onCancel={this.props.onCancel}
                onOk={this.props.onHandleOkImportarCompra}

            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                <Input.Search
                                    placeholder="Búsqueda por Serie o Documento"
                                    autoComplete="off"
                                    maxLength={100}
                                    onSearch={value => this.props.handleSearch(value)}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                key="table-cabecera-oc"
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowClassName='cursor-pointer'
                                onRow={
                                    (item) => ({ onClick: () => (this.props.onChangeRow(item)) })
                                }
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Serie',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        sorter: true
                                    },
                                    {
                                        title: 'Documento',
                                        dataIndex: 'documento',
                                        key: 'documento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Tipo Documento Proveedor',
                                        dataIndex: 'nombreTipoDocumentoProveedor',
                                        key: 'nombreTipoDocumentoProveedor',
                                        sorter: true
                                    },
                                    {
                                        title: 'Número de Documento',
                                        dataIndex: 'numeroDocumentoProveedor',
                                        key: 'numeroDocumentoProveedor',
                                        sorter: true
                                    },
                                    {
                                        title: 'Proveedor',
                                        dataIndex: 'razonSocialProveedor',
                                        key: 'razonSocialProveedor',
                                        sorter: true,
                                        render: (value) => (
                                            <div style={{ minWidth: "150px" }}>{value}</div>
                                        )
                                    },
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr',
                                        sorter: true
                                    },
                                    {
                                        title: 'Estado',
                                        dataIndex: 'nombreCompraEstado',
                                        key: 'nombreCompraEstado',
                                        align: 'center',
                                        width: "90px",
                                        fixed: 'right',
                                        render: (value, row) => {
                                            return (<div className="custom-options" >
                                                <Tag color={renderColor(row)}>{value}</Tag>
                                            </div>)
                                        }
                                    }
                                ]}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                key="table-detalle-oc"
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.idProducto}
                                dataSource={this.props.formValues.dataSourceDetalle}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Código',
                                        dataIndex: 'codigo',
                                        key: 'codigo',
                                        align: 'center',
                                        width: 80,
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre',
                                        width: 300,
                                        ellipsis: true,
                                    },
                                    {
                                        title: 'Unidad Medida',
                                        dataIndex: 'nombreUnidadMedida',
                                        key: 'nombreUnidadMedida',
                                        width: 120,
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Precio Unitario',
                                        dataIndex: 'precioUnitario',
                                        key: 'precioUnitario',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'Afecto',
                                        dataIndex: 'flagAfecto',
                                        key: 'flagAfecto',
                                        align: 'center',
                                        width: 62
                                    },
                                    {
                                        title: 'Cantidad',
                                        dataIndex: 'cantidad',
                                        key: 'cantidad',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'Sub Total',
                                        dataIndex: 'subTotal',
                                        key: 'subTotal',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'IGV',
                                        dataIndex: 'igv',
                                        key: 'igv',
                                        align: 'center',
                                        width: 80
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        fixed: 'right',
                                        align: 'center',
                                        width: 90
                                    }

                                ]}
                            />
                        </div>
                    </div>

                </Form>
            </Modal>
        );
    }
}